(function () {
  const $courseLists = document.querySelectorAll('.course-list');

  function initCourseList($courseList) {
    const $filters = $courseList.querySelectorAll('.filter'),
      $checkboxes = $courseList.querySelectorAll('.form-check-input'),
      $courses = $courseList.querySelectorAll(
        '.card:not(.card__empty-message)'
      ),
      $emptyMessage = $courseList.querySelector('.card__empty-message'),
      $activeFilterWrap = $courseList.querySelector('.active-filters'),
      $resetFiltersButton = $courseList.querySelector(
        '.active-filters__reset-filters'
      );

    let activeFilters = {
        degree: [],
        language: [],
        'study-start': [],
        'school-type': [],
      },
      changeEvent = new Event('change');

    function findLabel(filterGroup, value) {
      // Find checkbox by name and value, than select the next element and get content
      return $courseList.querySelector(
        '.form-check-input[name="' +
          filterGroup +
          '"][value="' +
          value +
          '"] + span'
      ).innerText;
    }

    function addFilterPill(filterGroup, value) {
      let newPill = document.createElement('span');
      newPill.classList.add('btn', 'btn-small', 'inline-close-icon');
      newPill.innerText = findLabel(filterGroup, value);
      newPill.dataset.value = value;
      newPill.dataset.filterGroup = filterGroup;
      $activeFilterWrap.appendChild(newPill);

      newPill.addEventListener('click', () => {
        const $checkbox = $courseList.querySelector(
          '.form-check-input[name="' + filterGroup + '"][value="' + value + '"]'
        );
        $checkbox.checked = false;
        $checkbox.dispatchEvent(changeEvent);
        newPill.remove();
      });
    }

    function removeFilterPill(filterGroup, value) {
      $courseList
        .querySelector(
          '.btn[data-filter-group="' +
            filterGroup +
            '"][data-value="' +
            value +
            '"]'
        )
        .remove();
    }

    function updateCourses() {
      let noMatches = true;

      $courses.forEach(($course) => {
        let degreeMatch = false,
          languageMatch = false,
          studyStartMatch = false,
          schoolTypeMatch = false;

        if (activeFilters['degree'].length === 0) {
          degreeMatch = true;
        } else {
          activeFilters['degree'].forEach((degreeFilter) => {
            if ($course.dataset.degree === degreeFilter) {
              degreeMatch = true;
            }
          });
        }

        if (activeFilters['language'].length === 0) {
          languageMatch = true;
        } else {
          activeFilters['language'].forEach((languageFilter) => {
            if ($course.dataset.languages.indexOf(languageFilter) > -1) {
              languageMatch = true;
            }
          });
        }

        if (
          activeFilters['study-start'].length === 0 ||
          parseInt($course.dataset.studyStart) === 2
        ) {
          studyStartMatch = true;
        } else {
          activeFilters['study-start'].forEach((studyStartFilter) => {
            if ($course.dataset.studyStart === studyStartFilter) {
              studyStartMatch = true;
            }
          });
        }

        if (activeFilters['school-type'].length === 0) {
          schoolTypeMatch = true;
        } else {
          activeFilters['school-type'].forEach((schoolTypeFilter) => {
            if ($course.dataset.schoolType.indexOf(schoolTypeFilter) > -1) {
              schoolTypeMatch = true;
            }
          });
        }

        if (
          degreeMatch &&
          languageMatch &&
          studyStartMatch &&
          schoolTypeMatch
        ) {
          $course.classList.remove('d-none');
          noMatches = false;
        } else {
          $course.classList.add('d-none');
        }
      });

      if (noMatches) {
        $emptyMessage.classList.remove('d-none');
      } else {
        $emptyMessage.classList.add('d-none');
      }
    }

    function addSelectionToFilters() {
      if (this.checked) {
        activeFilters[this.name].push(this.value);
        addFilterPill(this.name, this.value);
      } else {
        let index = activeFilters[this.name].indexOf(this.value);
        activeFilters[this.name].splice(index, 1);
        removeFilterPill(this.name, this.value);
      }

      updateCourses();
    }

    $checkboxes.forEach(($filter) => {
      $filter.addEventListener('change', addSelectionToFilters);
    });

    document.addEventListener('click', (event) => {
      $filters.forEach(($filter) => {
        if (!$filter.contains(event.target)) {
          $filter.open = false;
        }
      });
    });

    $resetFiltersButton.addEventListener('click', () => {
      $checkboxes.forEach(($checkbox) => {
        if ($checkbox.checked === true) {
          $checkbox.checked = false;
          $checkbox.dispatchEvent(changeEvent);
        }
      });
    });
  }

  $courseLists.forEach(($courseList) => {
    initCourseList($courseList);
  });
})();
